<template>

    <v-modal title="Edit Block">
        <template #body>
            <v-alert :message="error" />
            <form @keydown.enter.prevent="updateBlock">
                <v-form-group dir="ver" label="Name">
                    <v-input :model="block.name" @input="params.name = $event" />
                </v-form-group>
            </form>
        </template>
        <template #footer>
            <v-button size="sm" btn-style="white-danger" @click.native="deleteBlock">Delete</v-button>
            <v-button size="sm" :loading="loading" @click.native="updateBlock">Save Block</v-button>
        </template>

    </v-modal>

</template>

<script>

import BlockApi from '@api/BlockApi'

export default {

    props: {
        block: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            loading: false,
            error: null,
            params: {
                name: this.block.name,
            },
        }
    },

    methods: {

        updateBlock() {
            this.loading = true;
            BlockApi.updateBlock(this.block.id, this.params)
                .then((response) => {
                    this.loading = false;
                    this.$emit('saved');
                    this.$store.commit('showModal', false);
                })
                .catch((error) => {
                    this.loading = false
                    this.error = error.response.data.message
                });
        },

        deleteBlock() {
            this.$store.commit('showModal', 'delete');
        },

    },

}

</script>
